import { useState, useEffect } from "react";
import { Col, Row, Dropdown } from "react-bootstrap";
import { CustomAsyncSelect } from "components/Common/Common";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import useModal from "hooks/useModal";
import threDots_img from "Assets/images/three-dots.png";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import { STRATEGY_OPTIONS } from "config/constants";
import SaveStrategyTemplatePop from "components/Modals/SaveStrategyTemplatePop";
import StrategiesTemplatesPop from "components/Modals/StrategyTemplatesPop";
import { components } from "react-select";
import confirmDialogV2 from "utils/confirmationDialogV2";
import TaskStrategiesTemplateModal from "./StrategyTemplatesPop";
import { useLazyGetStartegyTemplatesQuery } from "store/services/clients/reports-v2/recommendationTemplates";

export const TaskTemplateStrategyForm = ({
    taskIndex,
    strategyIndex,
    setFieldValue,
    values,
    remove,
    setFieldTouched,
    assessmentId,
    clientType,
    errors,
    touched
}) => {
    const { show, data, open, close } = useModal();
    const { show: showTemplates, data: templatesData, open: templatesOpen, close: templatesClose } = useModal();
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const strategyPath = `strategy.${strategyIndex}`;
    const currentStrategy = values?.strategy?.[strategyIndex];

    // This function will be called from the modal when template is selected
    const handleTemplateSelectFromModal = (template) => {
        if (!template) return;

        // Create the selected template object in the format expected by CustomAsyncSelect
        const templateOption = {
            label: template.title || template.label,
            value: {
                id: template.id || template.value?.id,
                text: template.text || template.value?.text || "",
                attachments: template.attachments || template.value?.attachments || []
            },
            tags: template.tags || []
        };

        setSelectedTemplate(templateOption);

        // Update form values
        setFieldValue(`${strategyPath}.text`, templateOption.value.text);
        setFieldValue(`${strategyPath}.attachments`, templateOption.value.attachments);
        setFieldValue(`${strategyPath}.template_id`, templateOption.value.id);
        setFieldValue(`${strategyPath}.title`, templateOption.label);

        // Close the modal
        templatesClose();
    };

    const handleTemplateSelect = (selected) => {
        setSelectedTemplate(selected);
        setFieldValue(`${strategyPath}.text`, selected?.value?.answers || "");
        setFieldValue(`${strategyPath}.attachments`, selected?.value?.attachments || []);
        setFieldValue(`${strategyPath}.template_id`, selected?.value?.id);
        setFieldValue(`${strategyPath}.title`, selected?.label);
    };

    const handleDeleteStrategy = async (e) => {
        e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: "DELETE STRATEGY",
            message: "Are you sure you want to DELETE this strategy?",
        });
        if (!isConfirm) return;
        remove(strategyIndex);
        setFieldTouched(`tasks.${taskIndex}.strategy`, true);
    };

    // Update selected template when form values change
    useEffect(() => {
        if (currentStrategy?.template_id && currentStrategy?.title) {
            setSelectedTemplate({
                label: currentStrategy.title,
                value: {
                    id: currentStrategy.template_id,
                    text: currentStrategy.text || "",
                    attachments: currentStrategy.attachments || []
                }
            });
        } else {
            setSelectedTemplate(null);
        }
    }, [currentStrategy?.template_id, currentStrategy?.title, currentStrategy?.text, currentStrategy?.attachments]);

    const Option = (props) => {
        const { data, isSelected } = props;
        return (
            <components.Option {...props}>
                <div>
                    <div style={{ color: isSelected ? "#fff" : "#212529" }}>
                        {data.label}
                    </div>
                    {data.tags?.length > 0 && (
                        <div className="mt-1 d-flex flex-wrap gap-1">
                            {data.tags.map((tag, idx) => (
                                <div
                                    key={idx}
                                    className="rounded-pill"
                                    style={{
                                        pointerEvents: "none",
                                        fontWeight: "normal",
                                        backgroundColor: "#e8f5fe",
                                        color: "#007bff",
                                        border: "1px solid #007bff",
                                        padding: "1px 5px",
                                        fontSize: "12px"
                                    }}
                                >
                                    {tag}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </components.Option>
        );
    };
    const [getTemplates, { isFetching }] = useLazyGetStartegyTemplatesQuery();

    // Load templates function - implement based on your API
    const loadTemplates = async (search) => {
        try {
            const data = await getTemplates({ assessmentId, search, clientType, status: "" }).unwrap();
            const templates = data?.records || [];
            return templates?.map(i => {
                return {
                    label: i.title,
                    value: i,
                    // tags: i.StrategyTemplateTagsMapping
                    //     ?.map(tag => tag?.strategyTemplateTags?.name)
                    //     .filter(Boolean) || []
                }
            })
        } catch (error) {
            console.error("Error Getting template options", error);
        };
    };

    const strategyError =
        errors?.strategy?.[strategyIndex]?.text;

    const strategyTouched =
        touched?.strategy?.[strategyIndex]?.text;
 

    return (
        <>
            <SaveStrategyTemplatePop
                mainSetFieldValue={setFieldValue}
                taskIndex={taskIndex}
                strategyIndex={strategyIndex}
                showPopup={show}
                closePopup={close}
                data={data}
            />

            <TaskStrategiesTemplateModal
                mainSetFieldValue={setFieldValue}
                setSelectedTemplate={handleTemplateSelectFromModal} // Pass the handler function
                taskIndex={taskIndex}
                strategyIndex={strategyIndex}
                showPopup={showTemplates}
                closePopup={templatesClose}
                data={templatesData}
            />

            <Row className="ps-3">
                <Col style={{ borderBottom: "0.75px solid #000" }} className="px-0" lg="12">
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 className="m-0 proxima themeBlue fw-bold text-uppercase" style={{ fontSize: "12px" }}>
                            STRATEGY* {strategyIndex + 1}
                        </h6>
                        {
                            strategyIndex > 0 &&
                            < div className="cstm-dropdownclass">
                                <Dropdown>
                                    <Dropdown.Toggle id="dropdown-basic">
                                        <img width={19} height={18} src={threDots_img} alt="threDots_img" />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={handleDeleteStrategy}>Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        }

                    </div>
                </Col>

                <Col lg="4" className="px-0" style={{ margin: "12px 0" }}>
                    <p style={{ color: "#071e3e", fontStyle: "italic" }}>
                        Provide detailed strategies that would address the behavior or skill. Indicate clearly what you are trying to achieve with the strategies you are recommending.
                    </p>

                </Col>

                <Col lg="8" style={{ margin: "12px 0" }}>
                    {currentStrategy?.text || currentStrategy?.strategyRadio === "newStrategy" ? (
                        <>
                            {/* Show template dropdown only if there's a template_id or if we're in template selection mode */}
                            {(currentStrategy?.template_id || selectedTemplate) && (
                                <div className="reports-v2 justify-content-between gap-3 align-items-center" style={{ borderBottom: "0.75px solid #000000", padding: "0px 0" }}>
                                    <h6 className="proxima themeBlue" style={{ fontSize: "12px", fontWeight: "600", marginBottom: "10px" }}>
                                        Strategy Template
                                    </h6>
                                    <div className="w-100">
                                        <CustomAsyncSelect
                                            cstmOption={Option}
                                            placeholder="(no template selected)"
                                            loadOptions={loadTemplates}
                                            onChange={handleTemplateSelect}
                                            value={selectedTemplate}
                                            defaultOptions={true}
                                            isClearable={true}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="ck-editor-wrapper my-2">
                                <CustomEditor
                                    name={`${strategyPath}.text`}
                                    attachmentName={`${strategyPath}.attachments`}
                                />
                            </div>
                            {/* 
                            {!currentStrategy?.template_id && (
                                <button
                                    className="blue-discharge-screen-btn mt-0"
                                    type="button"
                                    onClick={() => {
                                        open({
                                            text: currentStrategy?.text,
                                        });
                                    }}
                                >
                                    Save to Templates
                                </button>
                            )} */}
                        </>
                    ) : (
                        <div className="session-input-radio text-area-report">
                            <div className="radio-inputs">
                                <AppRadioField
                                    containerClass="d-flex align-items-center py-1"
                                    options={STRATEGY_OPTIONS}
                                    name={`${strategyPath}.strategyRadio`}
                                    labelStyles={{
                                        color: "#071E3E",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        fontFamily: "Proxima Nova regular",
                                    }}
                                />

                                <button
                                    className="blue-discharge-screen-btn mt-3"
                                    type="button"
                                    disabled={!currentStrategy?.strategyRadio}
                                    onClick={() => {
                                        if (currentStrategy?.strategyRadio === "new") {
                                            setFieldValue(`${strategyPath}.strategyRadio`, "newStrategy");
                                            setFieldValue(`${strategyPath}.text`, "");
                                            setFieldValue(`${strategyPath}.attachments`, []);
                                            setFieldValue(`${strategyPath}.template_id`, "");
                                            setFieldValue(`${strategyPath}.title`, "");
                                            setSelectedTemplate(null);
                                        } else {
                                            templatesOpen();
                                        }
                                    }}
                                >
                                    Continue
                                </button>
                            </div>
                            {!(currentStrategy?.text || currentStrategy?.strategyRadio === "newStrategy") &&
                                (strategyTouched) &&
                                strategyError && (
                                    <div className="text-danger small mt-2">
                                        {strategyError}
                                    </div>
                                )}
                        </div>
                    )}
                </Col>
            </Row >
        </>
    );
};